import { createSlice } from "@reduxjs/toolkit";
import { 
  fetchCredentials, 
  createCredential, 
  updateCredential, 
  deleteCredential 
} from "../thunks/credentialsThunks";

const initialState = {
  credentials: [],
  loading: false,
  error: null,
};

const credentialsSlice = createSlice({
  name: "credentials",
  initialState,
  reducers: {
    fetchCredentialsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCredentialsSuccess(state, action) {
      state.credentials = action.payload;
      state.loading = false;
    },
    fetchCredentialsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredentials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCredentials.fulfilled, (state, action) => {
        state.credentials = action.payload;
        state.loading = false;
      })
      .addCase(fetchCredentials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(createCredential.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCredential.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createCredential.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(updateCredential.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCredential.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCredential.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(deleteCredential.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCredential.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteCredential.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  fetchCredentialsStart,
  fetchCredentialsSuccess,
  fetchCredentialsFailure,
} = credentialsSlice.actions;

export default credentialsSlice.reducer;
